import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  UPDATE_PROFILE,
  AUTH_CHECK_CONFIRMED_ACTION,
  NAVTOGGLE,
  TOGGLE_EMAIL_NOTIFICATION,
  TOGGLE_WHATSAPP_NOTIFICATION,
} from "../actions/AuthActions";

import { toast } from "react-toastify";
import { reportOption } from "../../utilities";

// Load saved reportType from localStorage (if exists)
const savedReportType = JSON.parse(localStorage.getItem("SELECTED_REPORT_TYPE"));

const initialState = {
  user: null,
  isCheckingAuth: true,
  errorMessage: "",
  successMessage: "",
  showLoading: false,
  reportType: savedReportType || reportOption[0],  // Load from localStorage else default
};

export function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_CONFIRMED_ACTION:
      return {
        ...state,
        user: action.payload,
        isCheckingAuth: false,
        showLoading: false,
      };

    case AUTH_CHECK_CONFIRMED_ACTION:
      return {
        ...state,
        isCheckingAuth: action.payload,
      };

    case UPDATE_PROFILE:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        showLoading: false,
      };

    case LOGOUT_ACTION:
      localStorage.removeItem("SELECTED_REPORT_TYPE");  // Clear reportType on logout
      return {
        ...state,
        isCheckingAuth: false,
        user: null,
        reportType: reportOption[0], // Reset reportType to default on logout
      };

    case LOGIN_FAILED_ACTION:
      toast.error(action.payload, { position: "top-left" });
      return {
        ...state,
        showLoading: false,
      };

    case LOADING_TOGGLE_ACTION:
      return {
        ...state,
        showLoading: action.payload,
      };

    case TOGGLE_EMAIL_NOTIFICATION:
      return {
        ...state,
        user: {
          ...state.user,
          is_allow_email_notification: action.payload,
        },
      };

    case TOGGLE_WHATSAPP_NOTIFICATION:
      return {
        ...state,
        user: {
          ...state.user,
          is_allow_whatsapp_notification: action.payload,
        },
      };

    case "UPDATE_REPORT":
      if (action.payload) {
        localStorage.setItem("SELECTED_REPORT_TYPE", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("SELECTED_REPORT_TYPE");
      }
      return {
        ...state,
        reportType: action.payload,
      };

    default:
      return state;
  }
}

// Toggle Menu Reducer (No changes needed here)
const initial = false;
export function toggleMenu(state = initial, action) {
  if (action.type === NAVTOGGLE) {
    return !state;
  }
  return state;
}
